export default __webpack_public_path__ + "static/dashboard.de-2e29b25fbfb3d011eb3ab92a13ee861e.svg";